"use client";

// Dev-only marker for articles still in `draft: true`.
//
// `isVisible()` (lib/ressources.ts) lets everything through in development, so
// drafts and scheduled articles sit in the listings next to the published ones
// with nothing to tell them apart. This badge singles out the drafts — the ones
// still waiting for a human read-through — and never the scheduled articles,
// which are already validated and only wait for their date.
//
// `process.env.NODE_ENV` is inlined by the bundler, so in a production build the
// guard folds to `false` and the badge is never rendered nor shipped as markup.
const IS_DEV = process.env.NODE_ENV === "development";

export function DraftBadge({ draft, className = "" }: { draft?: boolean; className?: string }) {
  if (!IS_DEV || !draft) return null;

  return (
    <span
      title="Article en brouillon — visible en développement uniquement"
      className={`inline-flex items-center gap-1.5 rounded-full bg-amber-400 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-amber-950 shadow-sm ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-900" aria-hidden="true" />
      Draft
    </span>
  );
}
